// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Db1uO","content":"Consent_content__ZzPs9","footer":"Consent_footer__2Nm1b"};